/**
 * clickable-message-dates.js — FID-03 round-four item 3 (Lucas ruling):
 * DISPLAY-LAYER date emphasis in fitment messages, sitewide.
 *
 * Pattern: "before MM/YYYY" / "after MM/YYYY" (slash or dot separators).
 * The matched phrase is wrapped in span.ck-msg-date — semibold carries the
 * emphasis, colour inherits from the message. PURE DISPLAY:
 * properties[Warning] and every stored/transmitted string stay verbatim;
 * unmatched messages render exactly as-is.
 *
 * SINGLE OWNER of the rule. JS painters (card chips, PDP message slot and
 * warning band, ATC toast) call window.clickableHighlightFitmentDates(el)
 * after writing textContent — guarded, so plain text stands if this file
 * is absent. Liquid-rendered surfaces (cart page + drawer line warnings,
 * fitment-table row notes) auto-enhance below, re-run after cart renders.
 * Text-node walking only — data is never parsed as markup.
 */
(function () {
  'use strict';

  // Round-five simplification (Lucas): colour + semibold apply to the
  // KEYWORD only — the date renders in the message's normal style. The
  // full phrase still gates the match (a bare "before" never styles).
  var PATTERN = /\b(before|after)(\s+\d{1,2}[/.]\d{4})\b/gi;

  function enhance(el) {
    if (!el) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) {
      var node = walker.currentNode;
      if (node.parentElement && node.parentElement.closest('.ck-msg-date')) continue;
      PATTERN.lastIndex = 0;
      if (PATTERN.test(node.nodeValue)) nodes.push(node);
    }
    nodes.forEach(function (node) {
      var text = node.nodeValue;
      var frag = document.createDocumentFragment();
      var last = 0;
      var match;
      PATTERN.lastIndex = 0;
      while ((match = PATTERN.exec(text)) !== null) {
        if (match.index > last) {
          frag.appendChild(document.createTextNode(text.slice(last, match.index)));
        }
        var span = document.createElement('span');
        // Semantic hue per direction (r5 amendment): the keyword wraps,
        // the date follows as plain text in the message's own style.
        var direction = /^before/i.test(match[1]) ? 'before' : 'after';
        span.className = 'ck-msg-date ck-msg-date--' + direction;
        span.textContent = match[1];
        frag.appendChild(span);
        frag.appendChild(document.createTextNode(match[2]));
        last = match.index + match[1].length + match[2].length;
      }
      if (last < text.length) {
        frag.appendChild(document.createTextNode(text.slice(last)));
      }
      node.parentNode.replaceChild(frag, node);
    });
  }

  window.clickableHighlightFitmentDates = enhance;

  // Liquid-rendered surfaces: cart page + drawer line warnings, fitment-
  // table row notes. Idempotent (wrapped spans are skipped), re-run when
  // cart surfaces re-render.
  var LIQUID_SURFACES = '.clickable-cart-line-warning, [data-warn-text]';

  function enhanceAll() {
    document.querySelectorAll(LIQUID_SURFACES).forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', enhanceAll);
  document.addEventListener('clickable:toast-shown', function () {
    setTimeout(enhanceAll, 400);
  });
  /* Named trap (struck 11 Aug r1 sweep): PUB_SUB_EVENTS is a bare
     top-level const — window.PUB_SUB_EVENTS is always undefined, so this
     resync was silently dead. Bare-identifier typeof guard. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(enhanceAll, 400);
    });
  }
})();
